import type { EndCardOverlay, TelopFont, VenueId } from '@shared/types'
import { useEditorStore } from '../../../../store/editorStore'
import { CheckboxField, SelectField, TextAreaField, TextField } from '../../../common/Field'
import { InspectorFrame } from './InspectorFrame'
import { OVERLAY_KIND_LABEL } from '../overlayMeta'
import { FONT_SELECT_LABEL, FONT_SELECT_ORDER } from './fontOptions'

/** 旧 TabEndCard.tsx の単体編集フィールドを選択駆動インスペクタへ切り出したもの。 */
export function EndCardInspector({ overlay }: { overlay: EndCardOverlay }) {
  const updateOverlay = useEditorStore((s) => s.updateOverlay)
  function patch(p: Partial<EndCardOverlay>) {
    updateOverlay(overlay.id, p)
  }

  return (
    <InspectorFrame
      title={OVERLAY_KIND_LABEL.end}
      overlayId={overlay.id}
      overlayKind="end"
      startSec={overlay.startSec}
      durationSec={overlay.durationSec}
      minDurationSec={0.5}
      maxDurationSec={10}
    >
      <TextAreaField
        label="行 (1行1要素)"
        rows={4}
        value={overlay.lines.join('\n')}
        onChange={(e) => patch({ lines: e.target.value.split('\n') })}
      />
      <CheckboxField label="縦書き" checked={overlay.vertical} onChange={(vertical) => patch({ vertical })} />
      <TextField
        label="CTA"
        value={overlay.cta ?? ''}
        placeholder="例: 詳細はプロフィールから"
        onChange={(e) => patch({ cta: e.target.value })}
      />
      <SelectField label="会場" value={overlay.venue} onChange={(e) => patch({ venue: e.target.value as VenueId })}>
        <option value="ginza">銀座 (GINZA)</option>
        <option value="nagoya">名古屋 (NAGOYA)</option>
        <option value="saitama">さいたま (SAITAMA)</option>
        <option value="generic">汎用</option>
      </SelectField>
      {/* P10-1: 未定義は「ゴシック」として表示。 */}
      <SelectField
        label="フォント"
        value={overlay.font ?? 'gothic'}
        onChange={(e) => patch({ font: e.target.value as TelopFont })}
        data-testid="overlay-font-select"
      >
        {FONT_SELECT_ORDER.map((f) => (
          <option key={f} value={f}>
            {FONT_SELECT_LABEL[f]}
          </option>
        ))}
      </SelectField>
    </InspectorFrame>
  )
}
